module.exports = __webpack_public_path__ + "static/media/youtubePodcastBadge.6139bab8.png";